import {FC, useEffect, useState} from 'react';
import {styled} from 'styled-components';
import {useParams, useSearch} from 'wouter';

import {NavButton, UnthemedNavLink} from '@shared-web/components/core/button';
import {notifyError} from '@shared-web/lib/notification';
import {useStringArrayQueryString} from '@shared-web/lib/use_query_string';

import {ChatGptMarkdown} from '@src/components/chat_gpt_markdown';
import {LoadingScreen} from '@src/components/loading_screen';
import {apiCall} from '@src/lib/api';
import {Team} from '@src/lib/teams';

export const TeamMetaPage: FC = () => {
  const queryString = useSearch();
  const [teamBlue] = useStringArrayQueryString(Team.Blue, []);
  const [teamRed] = useStringArrayQueryString(Team.Red, []);
  const {model} = useParams();

  const [meta, setMeta] = useState<string | undefined>();

  // Fetch information about the teams champions
  useEffect(() => {
    if (model === undefined) {
      return;
    }
    setMeta(undefined);
    apiCall('POST /gpt-team-meta', {model, teamBlue, teamRed})
      .then(({data}) => setMeta(data))
      .catch(notifyError);
  }, [model, teamBlue, teamRed]);

  return (
    <WrapperLink to={`/overview?${queryString}`}>
      {meta === undefined ? (
        <LoadingScreen />
      ) : (
        <>
          <NavButtons>
            {['gpt-4o-mini', 'gpt-4o', 'o1-preview'].map(m => (
              <ModelNavButton $active={model === m} key={m} to={`/meta/${m}?${queryString}`}>
                {m}
              </ModelNavButton>
            ))}
          </NavButtons>
          <ChatGptMarkdown message={meta} />
        </>
      )}
    </WrapperLink>
  );
};

TeamMetaPage.displayName = 'TeamMetaPage';

const WrapperLink = styled(UnthemedNavLink)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  padding: 16px;
  overflow: auto;
  position: fixed;
  width: calc(100% - 32px);
  top: 16px;
  right: 16px;
  bottom: 16px;
  left: 16px;
  border-radius: 10px;
  background: #3737438c;
  z-index: 100;
`;

const NavButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: center;
`;

const ModelNavButton = styled(NavButton)<{$active: boolean}>`
  ${p => p.$active && 'outline: solid 2px #47477e;'}
`;
